import { render } from "./AdminStudentAssigment.vue?vue&type=template&id=08a89630&scoped=true"
import script from "./AdminStudentAssigment.vue?vue&type=script&lang=js"
export * from "./AdminStudentAssigment.vue?vue&type=script&lang=js"

import "./AdminStudentAssigment.vue?vue&type=style&index=0&id=08a89630&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a89630"]])

export default __exports__